module.exports = __webpack_public_path__ + "img/vial_of_memory.75d855c0.jpg";